export function getToken() {
  return sessionStorage.getItem("agenToken");
}

export function setToken(token) {
  return sessionStorage.setItem("agenToken", token);
}

/**
 * 将登录字段存储在sessionStorage中
 */
export function setStorage(item) {
  for (let i in item) {
    sessionStorage.setItem(i, item[i]);
  }
}
export function removeStorage() {
  sessionStorage.clear();
}
